import { useEffect, useRef } from 'react';

import { useAuth0 } from '@auth0/auth0-react';
import { Loader, authReducer } from '@bitstopco/bitstop-theme';
import { Stack, Typography } from '@mui/material';

import { AUTH0_LOGIN_PATH } from '@/constants/app/config';
import { useAppDispatch } from '@/store';

const { actions: authActions } = authReducer;

const LogoutV2 = () => {
  const dispatch = useAppDispatch();
  const { logout } = useAuth0();
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    if (hasLoggedOut.current) return;

    hasLoggedOut.current = true;

    dispatch(authActions.logout());
    logout({ logoutParams: { returnTo: `${window.location.origin}${AUTH0_LOGIN_PATH}` } });
  }, [dispatch, logout]);

  return (
    <Stack alignItems="center" gap={2} py={2} data-test="auth-logout-v2">
      <Loader />
      <Typography color="text.secondary">Signing you out...</Typography>
    </Stack>
  );
};

export default LogoutV2;
